import type Swiper from 'swiper';

export const loadHighResImage = (slide: HTMLElement): void => {
    const img = slide.querySelector('img') as HTMLImageElement;
    if (!img.dataset.srcset) return;

    img.srcset = img.dataset.srcset;

    img.onload = (): void => {
        if (!img.complete) return;

        delete img.dataset.srcset;
        img.dataset.loaded = 'true';
    };
};

export const loadLowResImage = (slide: HTMLElement): void => {
    const img = slide.querySelector('img') as HTMLImageElement;
    if (!img.dataset.src) return;

    img.src = img.dataset.src;
    img.onload = (): void => {
        if (!img.complete) return;

        delete img.dataset.src;
    };
};

export const progressivelyLoadImages = (
    swiper: Swiper,
    range: { start: number; end: number },
    callback: (slide: HTMLElement) => void
): void => {
    for (let i = range.start; i < range.end; i++) {
        callback(swiper.slides[i]);
    }
};
